<template>
  <div class="welfare wrapW">
    <img class="welfareH" src="~@/assets/img/welfareH.png">
    <div class="Wdescribe">使用赋能系统体验区</div>
    <div class="center">
      <ul>
        <li v-for="(i,index) in list" :key="index">
          <div class="liCenter">
            <div class="img"><img :src="i.img"></div>
            <div class="imgA"><img :src="i.imgSelect"></div>
            <div class="name">{{i.name}}</div>
            <div class="info" v-html="i.desc"></div>
            <div class="button"><a :href="i.url">立即体验</a></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welfareO',
  data () {
    return {
    list: [],
    }
  },
  mounted () {
    this.getExperience()
  },
  methods: {
    getExperience () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getExperience', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res.list
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.welfare
  text-align center
  padding .69rem 0
  background-image url('~@/assets/img/welfareHB.png')
  background-size 100%
  background-position-y .3rem
  background-repeat no-repeat
  .welfareH
    height .23rem
  .Wdescribe
    font-size .24rem
    margin-top .22rem
    color #666
    letter-spacing .04rem
  .shu
    width 1px
    height .5rem
    background #BBBBBB
    margin 0 auto
    margin-top .2rem
  .shu_xian
    width 4.68rem
    height .5rem
    border 1px solid #BBBBBB
    border-bottom 0px
    margin 0 auto
  .center
    display flex
    justify-content center
    ul
      width 100%
      justify-content space-between
      display flex
      margin-top .68rem
      li
        width 22.5%
        padding .12rem
        height 3.9rem
        .liCenter
          width 100%
          height 100%
          position relative
          padding-top .3rem
        .img,.imgA
          width .76rem
          height .76rem
          background #D22016
          border-radius 50%
          margin 0 auto
          margin-bottom .3rem
          img
            height .48rem
            margin-top .14rem
        .imgA
          display none
          background #fff
        .name
          color var(--hei)
          font-size .18rem
        .info
          font-size .14rem
          color #666
          line-height .25rem
          margin-top .27rem
        .button
          width 42%
          height .3rem
          line-height .3rem
          background #D22016
          border-radius .15rem
          color #fff
          font-size .16rem
          margin 0 auto
          position absolute
          bottom .25rem
          left 29%
      li:hover
        background #D22016
        .liCenter
          border 2px solid #fff
          .imgA
            display block
          .img
            display none
          .name,.info
            color #fff
          .button
            color #D22016
            background #fff
            a
              color #D22016
</style>



// WEBPACK FOOTER //
// src/pages/index/components/welfareH.vue